import api from './api';
import { Client, AdminCreateClientRequest, AdminUpdateClientRequest } from '../types/client.types';

export const clientService = {
    getAllClientsAdmin: async (search?: string): Promise<Client[]> => {
        const response = await api.get('/admin/clients', {
            params: { search: search || undefined }
        });
        return response.data;
    },

    getClientByIdAdmin: async (id: number): Promise<Client> => {
        const response = await api.get(`/admin/clients/${id}`);
        return response.data;
    },

    createClientAdmin: async (data: AdminCreateClientRequest): Promise<Client> => {
        const response = await api.post('/admin/clients', data);
        return response.data;
    },

    updateClientAdmin: async (id: number, data: AdminUpdateClientRequest): Promise<Client> => {
        const response = await api.put(`/admin/clients/${id}`, data);
        return response.data;
    },

    deleteClientAdmin: async (id: number): Promise<void> => {
        await api.delete(`/admin/clients/${id}`);
    }
};
